import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a23127"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, "Menu", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu", true)!

  return (_openBlock(), _createBlock(_component_TabMenu, null, {
    item: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menuContainer) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "menu-item",
          key: "menuContainer",
          to: menuContainer.route
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(
            menuContainer.class +
            ' ' +
            _ctx.isActive(_ctx.$route, menuContainer.route) +
            ' menu-icon'
          )
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass('item ' + _ctx.isActive(_ctx.$route, menuContainer.route))
            }, _toDisplayString(menuContainer.name), 3)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      _createElementVNode("a", {
        class: "menu-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
      }, _hoisted_3)
    ]),
    _: 1
  }))
}